import { parseISO } from "date-fns";
import { AnniversaryProfile, BirthdayProfile } from "../../../apis/profileApi";

export const celebrationTypes = ["all", "birthday", "anniversary"] as const;

export type CelebrationType = (typeof celebrationTypes)[number];

export interface CelebrationItem {
  uuid: string;
  primaryImage: string;
  firstName: string;
  lastName: string;
  date: Date;
  type: string;
  celebrationType: "birthday" | "anniversary";
}

/**
 * Converts a profile to a birthday celebration item.
 * The returned date will have the current year to make it be able to sort by day and month.
 */
export function convertToCelebrationBirthday(
  profile: BirthdayProfile,
): CelebrationItem {
  return {
    uuid: profile.userUuid,
    primaryImage: profile.primaryImage,
    firstName: profile.firstName,
    lastName: profile.lastName,
    date: new Date(profile.birthdayDate),
    type: `BIRTHDAY (${diffInYears(profile.dob, profile.birthdayDate)})`,
    celebrationType: "birthday" as const,
  };
}

/**
 * Converts a profile to a birthday celebration item.
 * The returned date will have the current year to make it be able to sort by by day and month.
 */
export function convertToCelebrationAnniversary(
  profile: AnniversaryProfile,
): CelebrationItem {
  return {
    uuid: profile.userUuid,
    primaryImage: profile.primaryImage,
    firstName: profile.firstName,
    lastName: profile.lastName,
    date: new Date(profile.anniversaryDate),
    type: `(${diffInYears(
      profile.memberSince,
      profile.anniversaryDate,
    )} YR) ANNIVERSARY`,
    celebrationType: "anniversary" as const,
  };
}

/**
 * Return the difference in years between two dates.
 */
function diffInYears(from: string, to: string): number {
  return parseISO(to).getFullYear() - parseISO(from).getFullYear();
}
